import { Link } from 'react-router-dom';
import OmHeader from '../ui/OmHeader';
import OmButton from '../ui/OmButton';

const ClaimsListHeader = ({ 
  isMyClaimsView, 
  userRoles, 
  isLoading, 
  onRefresh,
  canExport,
  onExportCSV,
  isExporting,
  summaryStatsComponent // Add this prop to render the stats card
}) => {
  // Generate context-aware subtitle based on current view
  const getSubtitle = () => {
    if (isMyClaimsView) {
      return "Your submitted insurance claims";
    }
    
    return "All insurance claims in the system";
  };
  return (
    <div className="mb-8">
      {/* Render summary stats at the top if provided */}
      {summaryStatsComponent && (
        <div className="mb-6">
          {summaryStatsComponent}
        </div>
      )}
      
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        <div 
          className="om-header-custom"
          style={{
            '--omk-large-page-header-text-color': 'var(--color-deep-jungle)',
            '--omk-large-page-subheader-text-color': 'var(--color-graphite)',
            '--omk-large-page-header-container-bottom-padding': '0px'
          }}
        >
          <OmHeader 
            header={isMyClaimsView ? 'My Claims' : 'Claims Management'}
            subHeader={getSubtitle()}
            type="large-page-header"
          />
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3">
          {/* Export CSV button */}
          {canExport && (
            <OmButton
              onClick={onExportCSV}
              disabled={isExporting || isLoading}
              buttonType="outlined-button"
              buttonSize="medium"
              leadingIcon="download"
            >
              {isExporting ? 'Exporting...' : 'Export CSV'}
            </OmButton>
          )}
          
          {/* Refresh button */}
          <OmButton
            onClick={onRefresh}
            disabled={isLoading}
            buttonType="text-button"
            buttonSize="medium"
            leadingIcon="refresh"
          >
            {isLoading ? 'Refreshing...' : 'Refresh'}
          </OmButton>
          
          {(userRoles.includes('HR') || userRoles.includes('Broker') || userRoles.includes('CRM')) && (
            <Link to="/claims/submit" style={{ textDecoration: 'none' }}>
              <OmButton
                buttonType="filled-button"
                buttonSize="medium"
                leadingIcon="add"
              >
                Submit New Claim
              </OmButton>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClaimsListHeader;
